export default __webpack_public_path__ + "static/arcanum_hero-b3b3f199c274e48a900eadd8b9b6b8d1.mp4";